export default __webpack_public_path__ + "static/media/EADS.35fb2ebc.png";